// @ts-check

import { Col, Divider, Popover, Row, Space } from "antd";
import { MapContainer } from "react-leaflet";
import { DeviceProvider } from "../contexts/device-context";
import GardenProvider, { useGarden } from "../contexts/garden-context";
import { MapsProvider } from "../contexts/maps-context";
import { OptimizationProvider } from "../contexts/optimization-context";
import { PlansProvider } from "../contexts/plans-context";
import "./GardenList.css";
import "./Scheduler.css";

export default function Scheduler2() {
  const { garden, isOptimizationsPanelOpened, updateIsOptimizationsPanelOpened } = useGarden();

  if (!garden) return null;

  return (
    <GardenProvider.PageHeader>
      <Row gutter={[12, 12]}>
        <Col md={12} xs={24} style={{ display: "flex" }}>
          <MapContainer center={[41, 29]} style={{ borderColor: "lightgray", borderRadius: 12, borderWidth: 1, height: "100%" }} zoom={13} zoomControl={false}>
            <MapsProvider>
              <MapsProvider.Container>
                <MapsProvider.GardenLayersControl>
                  <MapsProvider.GardenAreas />
                  <MapsProvider.GardenDevices />
                </MapsProvider.GardenLayersControl>
              </MapsProvider.Container>
            </MapsProvider>
          </MapContainer>
        </Col>

        <Col md={12} xs={24} style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ position: "relative" }}>    
            {/* Device List */}
            <DeviceProvider.DevicesList height={"40vh"} />
          </div>
        </Col>

        <Col span={24}>
          <Divider style={{ margin: "16px 0" }} />
          <PlansProvider.PlansHeader />
        </Col>
      </Row>
    </GardenProvider.PageHeader>
  );
}
